import React, { useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { ContentContext } from "@/pages/Layout";
import PageCover from "@/components/PageCover";
import Media from "@/components/Media";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export default function News() {
  const { t, loc } = useApp();
  const content = useContext(ContentContext);
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState(null);

  useEffect(() => { api.get("/news").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="news-page">
      <PageCover testId="news-cover" image={content?.covers?.news} overline="Journal" title={t("news")} />

      <div className="px-6 md:px-12 py-16 md:py-24">
        <div className="max-w-[1600px] mx-auto">
          {items.length === 0 ? (
            <p data-testid="news-empty" className="text-sm text-neutral-500">{t("noItems")}</p>
          ) : (
            <div className="flex flex-col gap-6">
              {items.map((n, i) => (
                <button key={n.id} data-testid={`news-card-${i}`} onClick={() => setSel(n)}
                  className="group grid grid-cols-1 md:grid-cols-12 gap-6 text-left border border-white/5 bg-[#0c0c0c] hover:border-gold/30 transition-colors duration-300">
                  <div className="md:col-span-5 aspect-video md:aspect-[16/11] overflow-hidden">
                    <Media item={n.media?.[0]} className="transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="md:col-span-7 p-7 md:py-10 md:pr-10">
                    <p className="text-[0.62rem] uppercase tracking-[0.2em] text-gold">{n.date}</p>
                    <h3 className="font-serif text-3xl md:text-4xl text-white mt-3">{n.title}</h3>
                    <p className="text-sm text-neutral-500 mt-4 line-clamp-3">{loc(n.content)}</p>
                    <span className="inline-block mt-6 text-[0.68rem] uppercase tracking-[0.22em] text-neutral-400 group-hover:text-gold transition-colors duration-300">{t("readMore")}</span>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <Dialog open={!!sel} onOpenChange={() => setSel(null)}>
        <DialogContent data-testid="news-dialog" aria-describedby={undefined} className="bg-[#0a0a0a] border border-white/10 max-w-3xl p-0">
          {sel && (
            <div className="max-h-[85vh] overflow-y-auto scrollbar-thin">
              <div className="p-8 pb-4">
                <p className="overline">{sel.date}</p>
                <DialogTitle className="font-serif text-4xl font-light text-white mt-3">{sel.title}</DialogTitle>
                <p className="text-sm text-neutral-300 mt-6 leading-relaxed whitespace-pre-line">{loc(sel.content)}</p>
              </div>
              <div className="grid grid-cols-1 gap-1 p-1">
                {(sel.media || []).map((m, i) => (
                  <div key={i} className="aspect-video"><Media item={m} testId={`news-media-${i}`} /></div>
                ))}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
